const apiUrl =
	process.env.NODE_ENV === 'production'
		? process.env.VUE_APP_URL
		: 'http://localhost:8735'

declare global {
	interface Window {
		location: Location
	}
}

export default {
	get,
	post,
	postFormData,
	delete: deleteFetch,
	put,
}

async function get(url) {
	let response: Response

	try {
		response = await fetch(apiUrl + url, { ...getOptions() })
	} catch (e) {
		response = new Response(null, { status: 404, statusText: 'Offline' })
	}

	const body = await parseBody(response)
	if (handleErrors(response, body)) {
		return
	}

	return body
}

async function post(url, data) {
	const response = await fetch(apiUrl + url, {
		...getOptions(),
		method: 'POST',
		body: JSON.stringify(data || {}),
	})

	const body = await parseBody(response)
	if (handleErrors(response, body)) {
		return
	}

	return body
}

async function postFormData(url, data) {
	const response = await fetch(apiUrl + url, {
		method: 'POST',
		body: data,
	})

	const body = await parseBody(response)
	if (handleErrors(response, body)) {
		return
	}

	return body
}

async function put(url, data) {
	const response = await fetch(apiUrl + url, {
		...getOptions(),
		method: 'PUT',
		body: JSON.stringify(data || {}),
	})

	const body = await parseBody(response)
	if (handleErrors(response, body)) {
		return
	}

	return body
}

async function deleteFetch(url, data = {}) {
	const response = await fetch(apiUrl + url, {
		...getOptions(),
		method: 'DELETE',
		body: JSON.stringify(data),
	})

	const body = await parseBody(response)
	if (handleErrors(response, body)) {
		return
	}

	return body
}

function handleErrors(response, body) {
	let error = false

	for (const entry of response.headers.entries()) {
		if (entry[0] === 'location') {
			window.location.href = entry[1]
			error = true
			break
		}
	}

	// http 401: usuario nao esta logado
	if (response.status === 401) {
		window.location.href = '/login'
		// http 403: proibido
	} else if (response.status === 403) {
		let errorCode = ''
		if (body.cod) errorCode = '&cod=' + body.cod
		window.location.href =
			'/acesso-proibido?url=' + response.url + errorCode
	} else if (response.status !== 200) {
		console.error(
			'Looks like there was a problem. Status Code: ' + response.status,
		)
	}

	return error
}

function getOptions(): object {
	return {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		method: 'GET',
		// mode: 'cors',
		credentials: 'include',
	}
}

async function parseBody(response) {
	const data = await response.json().catch((e) => {
		console.error('e', e)
	})

	return data
}
